<template>
  <model-form
    ref="modelForm"
    :model="globalWidget"
    :handled-actions="handledActions"
    disable-language-select
    show-translation-notice
    @change="$emit('change')"
  >
    <div :styles="baseStyles">
      <div class="row q-col-gutter-md items-start">
        <q-select
          v-model="globalWidget.type"
          emit-value
          map-options
          class="col-6"
          label="Type"
          :options="globalWidget.fieldOptions('type')"
          :rules="[val => val !== null || 'Field is required']"
        />
        <model-form-input
          field="name"
          class="col"
          label="Name"
          :rules="[val => !!val || 'Field is required']"
        />
        <div class="col-auto q-mt-sm">
          <q-btn
            icon="settings"
            :disable="globalWidget.isTranslation"
            @click="$refs.genericGlobalWidgetSettings.show()"
          >
            <english-required-tooltip v-if="globalWidget.isTranslation" />
            <q-tooltip v-else>
              Visibility Settings
            </q-tooltip>
          </q-btn>
        </div>
      </div>
      <global-widget-banner-settings
        v-if="globalWidget.type === GLOBAL_WIDGET_TYPES.BANNER"
        :global-widget="globalWidget"
      />
      <q-banner
        v-if="!!foundNetlifyUrl"
        dense
        rounded
        class="bg-orange text-white col-12 q-mb-sm"
      >
        <template #avatar>
          <q-icon name="warning" />
        </template>
        Global widget content contains {{ foundNetlifyUrl }}
      </q-banner>
      <div :class="{ [globalWidget.scopeClass]: true }">
        <global-widget
          :global-widget
          is-editing
        />
      </div>
    </div>
    <global-widget-generic-settings-form
      ref="genericGlobalWidgetSettings"
      :global-widget="globalWidget"
    />
  </model-form>
</template>

<script>
import { GLOBAL_WIDGET_TYPES } from 'src/models/global-widget/GlobalWidget'
import EnglishRequiredTooltip from 'src/modules/admin/components/EnglishRequiredTooltip'
import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'
import GlobalWidgetGenericSettingsForm from 'src/modules/admin/global-widget/GlobalWidgetGenericSettingsForm'
import GlobalWidgetBannerSettings from 'src/modules/admin/global-widget/settings/GlobalWidgetBannerSettings.vue'
import GlobalWidget from 'src/modules/consumer/components/GlobalWidget'

export default {
  name: 'GlobalWidgetForm',
  components: {
    EnglishRequiredTooltip,
    ModelForm,
    GlobalWidgetGenericSettingsForm,
    GlobalWidget,
    GlobalWidgetBannerSettings
  },
  props: {
    handledActions: {
      type: Array,
      required: false,
      default () {
        return ['add', 'edit']
      }
    }
  },
  emits: ['change'],
  data () {
    return {
      showStartCalendar: false,
      showEndCalendar: false
    }
  },
  computed: {
    baseStyles () {
      return [
        this.currentSite.themeColorsCss,
        this.currentSite.transformedStyles || ''
      ].join(' ')
    },
    foundNetlifyUrl () {
      return this.$mh.foundNetlifyUrl(this.globalWidget.content)
    }
  },
  configuration: ['currentSite', 'publishedPages'],
  created () {
    _.extend(this, { GLOBAL_WIDGET_TYPES })
  },
  models: {
    globalWidget: {
      content: true,
      styles: true,
      transformedStyles: true,
      scopeClass: true,
      libraryDescendantSites: true,
      libraryChildSiteIds: true
    }
  },
  methods: {
    show (model, initialData) {
      this.$refs.modelForm.show(model, initialData)
    }
  }
}
</script>
